var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-image"},[_c('el-upload',{staticClass:"uploader",attrs:{"action":"","show-file-list":false,"http-request":_vm.uploadRequest,"before-upload":_vm.beforeAvatarUpload,"accept":_vm.filterPicType()}},[(_vm.image)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.image}}):_c('i',{staticClass:"el-icon-upload"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }